import { postJSON } from 'common/services/api'
import { useMutation, useQueryClient } from 'react-query'
import {
  ALLOCATION_LIST_QUERY_KEY,
  INSTANCES_CREATE_QUERY_KEY,
  INSTANCES_CREATE_URL,
  REVISIONS_QUERY_KEY
} from './queryConstants'

type UseInstancesCreateReturn = {
  createEvents?: (values: CreateEventsPayload) => Promise<unknown>
  isLoadingCreateEvents?: boolean
}

type CreateEventsPayload = {
  patternId?: string
}

const useInstancesCreate = (): UseInstancesCreateReturn => {
  const queryClient = useQueryClient()

  // Create events

  const createEventsFunction = async (
    values: CreateEventsPayload
  ): Promise<unknown> => {
    return postJSON({
      url: `${INSTANCES_CREATE_URL}/${values.patternId}`,
      method: 'POST',
      isRota: true
    })
  }

  const {
    mutateAsync: createEventsMutation,
    isLoading: isLoadingCreateEvents
  } = useMutation<unknown, unknown, CreateEventsPayload, unknown>(
    [INSTANCES_CREATE_QUERY_KEY],
    createEventsFunction,
    {
      onSuccess: () => {
        queryClient.invalidateQueries([REVISIONS_QUERY_KEY])
        queryClient.invalidateQueries([ALLOCATION_LIST_QUERY_KEY])
      }
    }
  )

  const handleCreateEvents = async (values: CreateEventsPayload) => {
    try {
      const result = await createEventsMutation(values)
      return result
    } catch (err) {
      return err
    }
  }

  return {
    createEvents: handleCreateEvents,
    isLoadingCreateEvents
  }
}

export default useInstancesCreate
